// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var imRouter = {
  path: '/im',
  component: Layout,
  redirect: '/im/group',
  name: 'Im',
  meta: {
    title: '群聊',
    icon: 'clipboard'
  },
  children: [{
    path: 'group',
    component: function component() {
      return import('@/views/im/group');
    },
    name: 'ImGroup',
    meta: {
      title: '群聊管理',
      icon: ''
    }
  }]
};
export default imRouter;